import '../scss/site.scss'
require('dotenv').config()

document.addEventListener('DOMContentLoaded', function (event) {})
